import { ComponentProps, ReactNode } from 'react';

import { FiltersProvider as FiltersProviderImpl } from '@spotify/confidence-core-react';

import { useOptionalPageBridgeProps } from '../../utils';
import { asPageWrapper } from '../composition';

export type PageFiltersProviderProps = Omit<
  ComponentProps<typeof FiltersProviderImpl>,
  'children' | 'storageKey' | 'persistence'
> & { storageKey?: string };

const BridgedFiltersProvider = ({
  storageKey,
  children,
  ...rest
}: PageFiltersProviderProps & { children: ReactNode }) => {
  const bridgeProps = useOptionalPageBridgeProps();
  const resolvedStorageKey = storageKey ?? bridgeProps?.descriptor.id ?? '';

  return (
    <FiltersProviderImpl storageKey={resolvedStorageKey} {...rest}>
      {children}
    </FiltersProviderImpl>
  );
};

export const FiltersProvider = asPageWrapper(
  (_props: PageFiltersProviderProps): null => null,
  BridgedFiltersProvider,
);
